import { Box, Typography } from '@mui/material'
import { t } from 'i18next'
import React, { ReactElement } from 'react'
import authStore from 'store/auth/auth'
import { useSnapshot } from 'valtio'

import styles from './StageBanner.module.less'

interface Props {
  inline?: boolean
}

export default function StageBanner({ inline }: Props): ReactElement | null {
  const authSnap = useSnapshot(authStore)
  const isPreview = authSnap.activeSystem?.is_preview
  const showStageBanner = process.env.REACT_APP_STAGE !== `production`

  if (!showStageBanner && !isPreview) return null

  return (
    <Box sx={{ display: { xs: 'none', md: 'block' } }}>
      <div
        className={`${styles.StageBanner_Container} ${inline ? styles['StageBanner_Container--static'] : styles['StageBanner_Container--fixed']}`}
      >
        {showStageBanner && (
          <Typography
            variant="body1"
            className={`${styles.StageBanner_Badge} ${process.env.REACT_APP_STAGE === `staging` ? styles['StageBanner_Badge--orange'] : styles['StageBanner_Badge--gray']}`}
          >
            {process.env.REACT_APP_STAGE === `staging` ? `STAGING` : `LOCAL DEV`}
          </Typography>
        )}
        {isPreview && (
          <Typography variant="body1" className={`${styles.StageBanner_Badge} ${styles['StageBanner_Badge--orange']}`}>
            {t(`PREVIEW SYSTEM`)}
          </Typography>
        )}
      </div>
    </Box>
  )
}
